import { withPluginApi } from "discourse/lib/plugin-api";
import { i18n } from "discourse-i18n";
import CommunityMediaGallery from "../components/community-media-gallery";

export default {
  name: "community-media",

  initialize(container) {
    const siteSettings = container.lookup("service:site-settings");
    if (!siteSettings.community_media_enabled) {
      return;
    }

    withPluginApi((api) => {
      api.addModelField("composer", "communityMediaPublishLabel");
      api.customizeComposerText({
        actionTitle(model) {
          if (model.communityMediaPublishLabel) {
            return i18n(model.communityMediaPublishLabel);
          }
        },
        saveLabel(model) {
          return model.communityMediaPublishLabel;
        },
      });

      api.renderInOutlet(
        "community-navigation-media-gallery-page",
        CommunityMediaGallery
      );
      api.renderInOutlet(
        "community-navigation-creator-resources-page",
        CommunityMediaGallery
      );
    });
  },
};
